export const postberbenoRakuvanjeData =
    [
        {
            id: "1", ime: "Не е релевантно, нема производи од животните"
        },
        {
            id: "2", ime: "Не релевантно: Погледај посебен извештај за преработка"
        }
    ]